import BaseTransitionConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/base';
import { DeepReadonly } from 'ts-essentials';
import { IFadeTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { ICTSlideTransition } from '@tencent/slide-sdk-pb-model';
import { DeepPartial } from '@src/slide/infrastructure/module/independent/ts-tools/deep-partial';

export default class FadeConverter extends BaseTransitionConverter {
    public convertPartialSdkToUi(
        sdkData: DeepReadonly<ICTSlideTransition>,
        uiData: IFadeTransition,
    ) {
        super.convertPartialSdkToUi(sdkData, uiData);

        uiData.throughBlack = sdkData.fade?.thruBlk;
    }

    public convertPartialUiToSdk(uiData: DeepPartial<IFadeTransition>, sdkData: ICTSlideTransition) {
        super.convertPartialUiToSdk(uiData, sdkData);

        const sdkFade = sdkData.fade || {};
        if (uiData.throughBlack !== undefined) {
            sdkFade.thruBlk = uiData.throughBlack;
        }

        sdkData.fade = sdkFade;
    }
}
